import {isFeatureEnabled} from '@github-ui/feature-flags'
import {hovercardAttributesForActor} from '@github-ui/hovercards'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {VALUES} from '../constants/values'
import type {AssignmentEventAssignee$key} from './__generated__/AssignmentEventAssignee.graphql'
import styles from './assignees.module.css'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const AssignmentEventAssigneeFragment = graphql`
  fragment AssignmentEventAssignee on Actor {
    ... on User {
      __typename
      login
      resourcePath
      name
    }
    ... on Mannequin {
      __typename
      login
      resourcePath
      name
    }
    ... on Organization {
      __typename
      login
      resourcePath
    }
    ... on Bot {
      __typename
      login
      resourcePath
      isCopilot
      displayName
      isAgent
    }
  }
`

type AssignmentEventAssigneeProps = {
  assigneeRef?: AssignmentEventAssignee$key | undefined | null
}

export function AssignmentEventAssignee({assigneeRef}: AssignmentEventAssigneeProps): React.ReactElement {
  const assignee = useFragment(AssignmentEventAssigneeFragment, assigneeRef)

  if (assignee?.__typename === '%other') return <></>

  const assigneeLogin = assignee?.login || VALUES.ghost.login
  const isCopilot = assignee?.__typename === 'Bot' && assignee.isCopilot
  const isAgent = assignee?.__typename === 'Bot' && assignee.isAgent
  const isUser = assignee?.__typename === 'User' || assignee?.__typename === 'Organization'
  const showHovercard = isUser || isCopilot
  const hovercardData = showHovercard ? hovercardAttributesForActor(assigneeLogin, {isCopilot}) : {}
  const displayName = isCopilot
    ? VALUES.copilot.displayName
    : isAgent
      ? assignee.displayName
      : assigneeLogin || VALUES.ghost.login
  const profileName = assignee?.__typename === 'User' || assignee?.__typename === 'Mannequin' ? assignee.name : null
  return (
    <Link {...hovercardData} href={assignee?.resourcePath} className={styles.assigneeLink} inline>
      {isFeatureEnabled('render_user_display_name') ? (
        <ProfileReference login={displayName} profileName={profileName} />
      ) : (
        displayName
      )}
    </Link>
  )
}

try{ AssignmentEventAssignee.displayName ||= 'AssignmentEventAssignee' } catch {}